<mat-card-content [ngStyle]="styles"><ng-content></ng-content></mat-card-content>
